import React, { FC } from 'react'

interface IProps {
  label: string
  href: string
  rf?: string
  ariaLabel?: string
  tabIndex?: number
  onClick?: () => void
}

const DropdownLinkItem: FC<IProps> = ({ label, onClick, href, ariaLabel, tabIndex, rf }) => (
  <li key={label}>
    <a onClick={onClick && onClick} href={href} aria-label={ariaLabel} tabIndex={tabIndex} data-testid={rf}>
      {label}
    </a>
  </li>
)

export { DropdownLinkItem, IProps }
